<template>
  <div>
    <div @click="dialog=true" style="height: 240px" class="w-60 g-box  mb-10 ma-auto">
      <v-img class="mb-3" height="240" style="position: relative" :src="item.photo_file">
        <div class="date-box" >
         <span class="d-flex align-center justify-center">
        {{item.title}}
      </span>
        </div>
      </v-img>
    </div>  <v-dialog width="500" class="d-flex justify-center align-center text-center" v-model="dialog">
    <v-card width="500" height="100%">
      <v-app-bar>
        <h5 style="width: 100%;">{{ item.title }}</h5>
        <div class="app-btn" @click="dialog=false">
          {{$t('close')}}
        </div>
      </v-app-bar>
      <div>
        <img alt="image" style="object-fit: fill"  :width="$vuetify.breakpoint.mdAndDown?'100%':'500'"  :src="item.photo_file"/>
      </div>
      <v-card-actions v-if="item.attach_file!=null" class="white text-center d-flex justify-center">
        <div class="app-btn" @click="downloadImage(item.attach_file, item.title)">
          {{$t('download')}}
        </div>
        <a :href="item.attach_file" @click="dialog=false" target="_blank" class="app-btn text-decoration-none mr-2">
          {{$t('see')}}
        </a>
      </v-card-actions>
    </v-card>
  </v-dialog></div>
</template>

<script>
export default {
  name: "GlassCatalogueItem",
  data(){
    return{
      dialog:false,
    }
  },
  methods:{
    downloadImage(url, name){
      fetch(url)
          .then(resp => resp.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(() => alert('An error sorry'));
    },
  },
  props:{
    item:Object
  }
}
</script>

<style scoped>
.date-box {
  padding: 6px 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}

.g-box:hover > * > * > .date-box {
  background-color: #2d5eb5;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}

.date-box > * {
  color: white;
  font-size: 16px !important;
}
</style>